import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { Reducer } from 'redux';
import { PersistPartial } from 'redux-persist/es/persistReducer';
import { put, takeLatest, call } from 'redux-saga/effects';
import { TAppActions } from '../rootDuck';
import { ActionsUnion, createAction } from '../../utils/action-helper';
import { IServerResponse } from '../../interfaces/server';
import { getResponseMessage } from '../../utils/utils';
import { getTransactions } from '../../crud/transactions.crud';
import { IITransactionParams, ITransaction } from '../../interfaces/transaction';

const CLEAR = 'transactions/CLEAR';
const FETCH_REQUEST = 'transactions/FETCH_REQUEST';
const FETCH_SUCCESS = 'transactions/FETCH_SUCCESS';
const FETCH_FAIL = 'transactions/FETCH_FAIL';
const SET_TRANSACTIONS = 'transactions/SET_TRANSACTIONS';

export interface IInitialState {
  transactionsData: ITransaction | null;
  loading: boolean;
  success: boolean;
  error: string | null;

  page: number;
  size: number;
  total: number;

  filter: { [key: string]: string[] };
}

const initialState: IInitialState = {
  transactionsData: null,
  loading: false,
  success: false,
  error: null,

  page: 0,
  size: 20,
  total: 0,

  filter: {},
};

export const reducer: Reducer<IInitialState & PersistPartial, TAppActions> = persistReducer(
  { storage, key: 'transactions', whitelist: ['transactionsData'] },
  (state = initialState, action: any) => {
    switch (action.type) {
      case CLEAR: {
        return { ...state, loading: false, success: false, transactionsData: null};
      }

      case FETCH_REQUEST: {
        return {
          ...state,
          transactionsData: null,
          loading: true,
          error: null,
          success: false,
        };
      }

      case FETCH_SUCCESS: {
        return {
          ...state,
          page: action.payload.number,
          size: action.payload.size,
          total: action.payload.totalElements,
          transactionsData: action.payload,
          loading: false,
          success: true,
        };
      }

      case FETCH_FAIL: {
        return { ...state, loading: false, error: action.payload, success: false };
      }

      default:
        return state;
    }
  }
);

export const actions = {
  clear: () => createAction(CLEAR),
  fetchRequest: (payload: IITransactionParams) => createAction(FETCH_REQUEST, payload),
  fetchSuccess: (payload: IServerResponse<ITransaction>) => createAction(FETCH_SUCCESS, payload),
  fetchFail: (payload: string) => createAction(FETCH_FAIL, payload),
  setTransactionsList: (payload: ITransaction[]) => createAction(SET_TRANSACTIONS, payload)
};

export type TActions = ActionsUnion<typeof actions>;

function* fetchSaga({ payload }: { payload: IITransactionParams }) {
  try {
    const { data }: { data: IServerResponse<ITransaction> } = yield call(() => getTransactions(payload));
    yield put(actions.fetchSuccess(data));
  } catch (e) {
    yield put(actions.fetchFail(getResponseMessage(e)));
  }
}

  export function* saga() {
    yield takeLatest<ReturnType<typeof actions.fetchRequest>>(FETCH_REQUEST, fetchSaga);
  }
